import { render, staticRenderFns } from "./mattersDirectory.vue?vue&type=template&id=41c8da26&scoped=true"
import script from "./mattersDirectory.vue?vue&type=script&lang=js"
export * from "./mattersDirectory.vue?vue&type=script&lang=js"
import style0 from "./mattersDirectory.vue?vue&type=style&index=0&id=41c8da26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8da26",
  null
  
)

export default component.exports